import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const standardTasksModule = {
  namespaced: true,
  state() {
    return {
      standardTasks: [],
    };
  },
  actions,
  getters,
  mutations,
};

export default standardTasksModule;
